var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "suggestion-list-component input-field",
      class: [_vm.state, _vm.loading ? "loading" : ""]
    },
    [
      _c("input-field", {
        attrs: {
          disable: _vm.disable,
          name: _vm.text,
          "icon-type": _vm.iconType,
          "input-type": "text",
          value: _vm.inputVal,
          select: true
        },
        on: {
          stopTyping: _vm.updateInputVal,
          key: _vm.keyEvent,
          input: _vm.onInputUpdate,
          blur: _vm.onBlur,
          focus: _vm.onFocus
        }
      }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "suggestion-list" },
        [
          _c(
            "transition-group",
            { attrs: { name: "list-transition" } },
            _vm._l(_vm.suggestionList, function(item, index) {
              return _c(
                "li",
                {
                  key: item,
                  staticClass: "suggestion-list__item",
                  class: { selected: index == _vm.selectedItem },
                  on: {
                    click: function($event) {
                      _vm.clickItem(index)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(item) + "\n      ")]
              )
            })
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b2721d6c", { render: render, staticRenderFns: staticRenderFns })
  }
}